export const IMAGE   = 'IMAGE';
export const PDF     = 'PDF';
export const VIDEO   = 'VIDEO';
export const AUDIO   = 'AUDIO';
export const SUCCESS = 'SUCCESS';
export const FAILURE = 'FAILURE';
export const NONE    = 'NONE';






// WEBPACK FOOTER //
// ./src/constants.js